import type { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './Modal.module.css';
import { Button } from './Button';

export function Modal({
  title,
  open,
  onClose,
  children,
  size = 'md',
  closeLabel = 'Close',
  showClose = true,
}: {
  title: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  /** `wide` / `xl` / `full` — more horizontal room (tables, forms). */
  size?: 'md' | 'wide' | 'xl' | 'full';
  /** Primary dismiss control (e.g. `Save` when closing applies in-memory state). */
  closeLabel?: string;
  /** Header close control; backdrop still calls `onClose` when enabled. */
  showClose?: boolean;
}) {
  if (!open) return null;
  return (
    <div className={styles.backdrop} role="presentation" onMouseDown={onClose}>
      <div
        className={clsx(
          styles.panel,
          size === 'wide' && styles.panelWide,
          size === 'xl' && styles.panelXl,
          size === 'full' && styles.panelFull
        )}
        role="dialog"
        aria-modal
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className={styles.head}>
          <h3 className={styles.title}>{title}</h3>
          {showClose ? (
            <Button variant="ghost" onClick={onClose}>
              {closeLabel}
            </Button>
          ) : null}
        </div>
        {children}
      </div>
    </div>
  );
}
